import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';

/**
 * Modal de confirmación reutilizable.
 *
 * Props opcionales (si no se pasan, se comporta igual que siempre — los usos
 * de Chat, Calendario y Contactos no necesitan tocarse):
 *   detalle          texto secundario debajo del mensaje principal
 *   inputLabel       si viene, muestra un campo de texto (ej. motivo de anulación)
 *   inputValue       valor controlado de ese campo
 *   onInputChange    handler del campo
 *   textoConfirmar   etiqueta del botón de confirmar (por defecto "Continuar")
 *   textoCancelar    etiqueta del botón de cancelar (por defecto "Deshacer")
 *   peligro          pinta el botón de confirmar en rojo (acciones destructivas)
 *   ocupado          deshabilita los botones mientras se procesa
 */
const ConfirmationModal = ({
  isVisible,
  message,
  onConfirm,
  onCancel,
  detalle,
  inputLabel,
  inputValue,
  onInputChange,
  textoConfirmar = 'Continuar',
  textoCancelar = 'Deshacer',
  peligro = false,
  ocupado = false,
}) => {
  if (!isVisible) return null;

  return (
    <AnimatePresence>
      <motion.div
        className="modal-overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.2 }}
      >
        <motion.div
          className="modal-content"
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -50, opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          <p>{message}</p>

          {detalle && (
            <p style={{ fontSize: '13px', color: '#666', fontFamily: 'Effra', margin: '-6px 0 4px' }}>
              {detalle}
            </p>
          )}

          {inputLabel && (
            <div className="input-group" style={{ margin: '4px 0 8px' }}>
              <input
                type="text"
                className="input"
                placeholder={inputLabel}
                value={inputValue ?? ''}
                onChange={(e) => onInputChange && onInputChange(e.target.value)}
                autoFocus
              />
            </div>
          )}

          <div className="modal-buttons">
            <button className="button-cancel" onClick={onCancel} disabled={ocupado}>
              {textoCancelar}
            </button>
            <button
              className="button-confirm"
              onClick={onConfirm}
              disabled={ocupado}
              style={peligro ? { backgroundColor: '#e65c5c', borderColor: '#e65c5c' } : undefined}
            >
              {ocupado ? 'Procesando...' : textoConfirmar}
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default ConfirmationModal;
